export const INCIDENT_CATEGORY_API = (communityId: string) => `v1/incident-categories/community/${communityId}`;
